'use client';

import * as React from 'react';
import { hydrate } from '@tanstack/query-core';
import { useQueryClient } from './QueryClientProvider.esm.js';

function useHydrate(state) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var queryClient = useQueryClient({
    context: options.context
  });
  var optionsRef = React.useRef(options);
  optionsRef.current = options; // Running hydrate again with the same queries is safe,
  // it wont overwrite or initialize existing queries,
  // relying on useMemo here is only a performance optimization.
  // hydrate can and should be run *during* render here for SSR to work properly

  React.useMemo(function () {
    if (state) {
      hydrate(queryClient, state, optionsRef.current);
    }
  }, [queryClient, state]);
}

var Hydrate = function Hydrate(_ref) {
  var children = _ref.children,
      options = _ref.options,
      state = _ref.state;
  useHydrate(state, options);
  return children;
};

export { Hydrate, useHydrate };